import React from 'react'
import { Image } from 'semantic-ui-react'

const AirlineLogo = ({ code, ...rest }) => {
  if (typeof code === 'undefined') return null
  if (code.toLowerCase() === 'sq') return null
  if (code.toLowerCase() === 'mi') return null

  return (
    <Image
      className='airline-logo'
      // src={`https://images.kiwi.com/airlines/128/${code}.png`}
      src={`https://api.fakeflighttickets.com/airline-logos/${code}.png`}
      // src={`https://www.fakeflighttickets.com/airline/${code}.png`}
      // src={`/airline/${code}.png`}
      {...rest}
      onError={e => {
        console.warn(`Image failed to load: ${e.target.src}`)
        e.target.remove()
      }}
    />
  )
}

// <Image fluid rounded src={`https://onward.flights/airlines/128/${airlines[0]}.png`} />
// <Image fluid rounded src={`https://onward.flights/airlines/128/${airlines[1]}.png`} />
// <Image fluid rounded src={`http://pics.avs.io/200/200/${airlines[0]}.png`} />
// <Image fluid rounded src={`http://pics.avs.io/200/200/${airlines[1]}.png`} />
// https://images.trvl-media.com/media/content/expus/graphics/static_content/fusion/v0.1b/images/airlines/vector/s/#{code}_sq.svg
export default AirlineLogo



// WEBPACK FOOTER //
// ./src/components/AirlineLogo.js